module.exports = __webpack_public_path__ + "static/media/user-white.79774622.svg";